import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PlaceDetailSkeletonProps {
  onBack?: () => void;
}

export const PlaceDetailSkeleton: React.FC<PlaceDetailSkeletonProps> = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero Skeleton */}
      <div className="relative w-full">
        <div className="h-56 sm:h-64 md:h-72 w-full bg-gray-200 animate-pulse" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        
        {/* Back button */}
        <div className="absolute top-4 left-4 z-40">
          <Button
            variant="glass"
            size="icon"
            onClick={onBack}
            className="w-10 h-10 rounded-full"
          >
            <ArrowLeft className="w-4 h-4" />
          </Button>
        </div>
        
        {/* Title skeleton */}
        <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6">
          <div className="h-8 w-3/4 bg-white/30 rounded animate-pulse mb-2" />
          <div className="h-5 w-1/2 bg-white/20 rounded animate-pulse" />
        </div>
      </div>
      
      {/* Content skeleton */}
      <div className="p-4 sm:p-6 space-y-6">
        {/* Audio player skeleton */}
        <div className="h-20 bg-gray-100 rounded-xl animate-pulse" />
        
        {/* Description skeleton */}
        <div className="space-y-3">
          <div className="h-4 bg-gray-100 rounded animate-pulse" />
          <div className="h-4 bg-gray-100 rounded animate-pulse w-5/6" />
          <div className="h-4 bg-gray-100 rounded animate-pulse w-4/6" />
        </div>
        
        {/* Info cards skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="h-32 bg-gray-100 rounded-xl animate-pulse" />
          <div className="h-32 bg-gray-100 rounded-xl animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default PlaceDetailSkeleton;
